import initVueApp from "@/core.js";
const component = require(`./../views/IndexSS23.vue`).default;
initVueApp(component);
